const step_up = {
    verify_your_identity: 'تحقق من هويتك',
    choose_method_description: 'للمتابعة، أكّد أنك أنت باستخدام إحدى الطرق التالية.',
    password: 'كلمة المرور',
    password_description: 'أدخل كلمة مرور حسابك',
    enter_password_description: 'أدخل كلمة مرور حسابك للمتابعة.',
    enter_verification_code_description: 'أدخل رمز التحقق المُرسل إلى {{identifier}}.',
    subject_proof_description: 'للمتابعة، أكّد أنك أنت من خلال حساب مرتبط بحسابك. يمكنك بعد ذلك إعداد طريقة تحقق.',
    no_method_available: 'لا توجد طريقة تحقق متاحة',
    no_method_available_description: 'لا يحتوي حسابك على أي طريقة يمكنها إكمال هذا التحقق. يرجى التواصل مع المسؤول للحصول على المساعدة.',
};
export default Object.freeze(step_up);
